import AdsenseContainer from '@/client/components/AdsenseContainer/AdsenseContainer';

export default AdsenseContainer;
